import React from 'react'
import './style.scss'
import celular from '../../assets/images/celular.png'

export default function SectionControl() {
	return (
		<section className="container-section-control">
			<div className="section-control-left">
				<h1>Indique seus amigos também!</h1>
				<div className="description calibri">
					Com o app Veloe, você gerencia seu 
					consumo e veículos cadastrados, realiza
					pagamento de faturas e faz recargas 
					com facilidade.
					<br /> <br />

					Além disso, você também pode indicar 
					outros amigos para curtir o caminho sem filas e com uma oferta exclusiva.
				</div>
			</div>
			<div className="container-image">
				<img src={celular} alt="" className="celular"/>
			</div>
		</section>
	)
}